import _ from 'lodash'
import $ from 'cash-dom'
import {fmt, s, greyscale, palette, rewind, ffwd, cancel, offset, sfc32, quadMinMax, bezierMinMax} from './util.js'

export default class Thermometer{
  constructor(book){
    this.book = book
  }

  get svg(){
    let PG_HEIGHT = 5,
        PG_WIDTH = 1


    let width = 180,
        height = 40;

    let {book} = this,
        {illustrations, endings, choices, pages, stats} = book

    let illos = _.countBy(_.values(illustrations)),
        // decisions = _.countBy(_.values(choices), dsts => dsts.length==1 ? 'forced' : 'choice')
        decisions = _.countBy(_.values(choices), _.size),
        maxChoices = _.max(_.map(_.values(choices), _.size))



    let y = 0,
        x = 0,
        h = 0,
        ct = 0,
        elts = []

    ct = (illos.inline||0) + (illos.spread||0) + (illos.full||0)
    h = PG_HEIGHT * ct
    _.times(ct, () => {
      elts.push(`<rect fill="#666" x="${x}" y="${y}" width="${PG_WIDTH}" height="${PG_HEIGHT}"/>`)
      // y += PG_HEIGHT + .25
      x += PG_WIDTH + .25
    })

    // h = PG_HEIGHT * decisions[1]
    // elts.push(`<rect fill="#333" x="${x}" y="${y}" width="${PG_WIDTH}" height="${h}"/>`)
    // y += h

    for (var i=1; i<=maxChoices; i++){
      let fill = i==1 ? '#333' : palette(1 - _.min([.25*(i-1), .8])),
          ct = decisions[i],
          h = PG_HEIGHT * ct
      if (decisions[i]){

        _.times(ct, () => {
          elts.push(`<rect fill="${fill}" x="${x}" y="${y}" width="${PG_WIDTH}" height="${PG_HEIGHT}"/>`)
          // y += PG_HEIGHT + .25
          x += PG_WIDTH + .25
        })
      }
    }


    ct = endings.length
    h = PG_HEIGHT * ct

    _.times(ct, () => {
      elts.push(`<rect fill="skyblue" x="${x}" y="${y}" width="${PG_WIDTH}" height="${PG_HEIGHT}"/>`)
      // y += PG_HEIGHT + .25
      x += PG_WIDTH + .25
    })


    // console.log(pages, 'pages total')
    // console.log(endings.length, 'endings')
    // console.log(stats.paths, 'unique paths')
    // console.log({illos})
    // console.log({decisions})




    return `<svg class="thermometer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">${
      elts.join('')
    }</svg>`
  }

}

